export default "__VITE_ASSET__RrBEwFEN__"